import React from "react"
import * as Icons from "@mui/icons-material"

const DynamicIcon = ({ iconName, style }) => {
  const IconComponent = Icons[iconName]

  if (!IconComponent) {
    return <span></span>
  }

  return <IconComponent style={style} />
}

export default DynamicIcon
